import { useEffect, useRef, useState } from 'react';
import { Input, Card, Button, List, Typography, Space, Tag, Empty, Switch } from 'antd';
import { CheckCircleFilled, UserOutlined, MailOutlined } from '@ant-design/icons';
import useOnScreen from '../../hooks/useOnScreen';
import { t } from '../../i18n/i18n';
import Spinner from '../spinner/Spinner';
import './ResetTestgroupStep3.scss';

const { Title, Text } = Typography;
const { Search } = Input;

const ResetTestgroupStep3 = ({
  handlePreviousStep,
  handleNextStep,
  loading,
  loadingInvitations,
  invitations,
  selectedInstances,
  selectedPrefilterInstances,
  handleSelectInstance,
  fetchSearchInvitations,
  clearSelectedInvitations,
  fetchNextPage,
  restartPrefilters,
  setRestartPrefilter,
}) => {
  const [search, setSearch] = useState('');
  const [fetched, setFetched] = useState(false);
  const fetchNextUrlRef = useRef();
  const fetchNextUrl = useOnScreen(fetchNextUrlRef, '0px', true);

  useEffect(() => {
    fetchSearchInvitations({ search });
  }, []);

  useEffect(() => {
    if (!fetchNextUrl) setFetched(false);
    if (
      fetchNextUrl &&
      !fetched &&
      invitations?.collection?.length &&
      invitations?.pagination.nextPage &&
      !loading &&
      !loading
    ) {
      fetchNextPage();
      setFetched(true);
    }
  }, [fetchNextUrl]);

  return (
    <div className="reset-step-container modern-step">
      <div className="step-header">
        <Title level={3} className="step-title">
          <UserOutlined className="step-icon" />
          {t('RESET_TESTGROUP_STEP_3_TITLE')}
        </Title>
      </div>

      <div className="step-content">
        <div className="toggle-section">
          <Card className="toggle-card" size="small">
            <Space align="center">
              <Text strong>{t('RESET_TESTGROUP_TYPE')}</Text>
              <Switch
                checked={!restartPrefilters}
                onChange={() => {
                  clearSelectedInvitations();
                  setRestartPrefilter(!restartPrefilters);
                }}
                disabled={!invitations?.collection?.some((inv) => inv?.prefilterInstanceId)}
                checkedChildren="Testgroups"
                unCheckedChildren="Pre-filtros"
              />
            </Space>
          </Card>
        </div>

        <div className="search-section">
          <Search
            placeholder={t('RESET_TESTGROUP_STEP_3_SEARCH_PLACEHOLDER')}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            onSearch={(value) => fetchSearchInvitations({ search: value })}
            className="modern-search"
            size="large"
          />
        </div>

        <div className="candidates-selection-area">
          {loading ? (
            <div className="loading-container">
              <Spinner show />
            </div>
          ) : (
            <>
              {invitations?.collection?.length ?
                <List
                  className="candidates-list"
                  dataSource={invitations?.collection?.filter((inv) =>
                    !restartPrefilters ? inv?.screeningInstanceId : inv?.prefilterInstanceId
                  )}
                  renderItem={(invitation) => (
                    <List.Item className="candidate-item">
                      <Card
                        hoverable
                        onClick={() => handleSelectInstance(invitation)}
                        className={`candidate-card ${(!restartPrefilters
                          ? selectedInstances.includes(invitation.screeningInstanceId)
                          : selectedPrefilterInstances.includes(invitation.prefilterInstanceId)
                        ) ? 'selected-card' : ''
                          }`}
                        size="small"
                      >
                        <div className="candidate-content">
                          <Space className="w-100 justify-content-between align-items-center">
                            <div className="candidate-info">
                              <Space>
                                <MailOutlined style={{ color: '#4987BE' }} />
                                <Text strong className="candidate-email">{invitation.email}</Text>
                              </Space>
                              {(invitation?.firstName || invitation?.lastName) &&
                                <>
                                  <br />
                                  <br />
                                  <Tag size="small" color="purple">{`${invitation?.firstName ?? ''} ${invitation?.lastName ?? ''}`}</Tag>
                                </>
                              }
                            </div>
                            {((!restartPrefilters
                              ? selectedInstances.includes(invitation.screeningInstanceId)
                              : selectedPrefilterInstances.includes(invitation.prefilterInstanceId)
                            )) && (
                                <CheckCircleFilled className="check-icon-candidate" />
                              )}
                          </Space>
                        </div>
                      </Card>
                    </List.Item>
                  )}
                />
                :
                <Empty
                  description={t('RESET_TESTGROUP_STEP_3_EMPTY_STATE_TITLE')}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  className="empty-state"
                />
              }

              {loadingInvitations && (
                <div className="loading-more">
                  <Spinner show />
                </div>
              )}
              <div ref={fetchNextUrlRef} />
            </>
          )}
        </div>
      </div>

      <div className="step-footer">
        <Space>
          <Button
            onClick={() => {
              clearSelectedInvitations();
              handlePreviousStep();
            }}
            className="back-btn"
            size="large"
          >
            {t('RESET_TESTGROUP_BACK_BUTTON')}
          </Button>
          <Button
            type="primary"
            onClick={handleNextStep}
            disabled={!selectedInstances.length && !selectedPrefilterInstances.length}
            className="next-step-btn"
            size="large"
          >
            {t('RESET_TESTGROUP_NEXT_BUTTON')} ({!restartPrefilters ? selectedInstances.length : selectedPrefilterInstances.length})
          </Button>
        </Space>
      </div>
    </div>
  );
};

export default ResetTestgroupStep3;
